<template>
  <div class="auth-left">
    <!-- Logo -->
     <div>
    <div class="auth-left__logo">
      <div class="auth-left__logo-wrap">
        <img
          v-if="!logoFailed"
          :src= "imageUrl" 
          :alt="logoText"
          class="auth-left__logo-img"
          @error="onLogoError"
        />
        <span v-if="logoFailed" class="auth-left__logo-text">{{ logoText }}</span>
        <div class="auth-left__logo-underline" />
      </div>
    </div>

    <!-- Tagline -->
    <p class="auth-left__tagline text-body">
      Хөрөнгийн зах зээл болон уул уурхайн нэгдсэн өгөгдөл, шинжилгээний цогц
      платформ.
    </p>
    </div>

    <!-- Carousel -->
    <!-- <div class="auth-left__carousel ">
      <transition name="fade" mode="out-in">
        <div :key="current" class="auth-left__slide">
          <div class="auth-left__slide-body">
            <blockquote class="auth-left__quote text-body">
              "{{ slides[current].text }}"
            </blockquote>
            <p class="auth-left__author text-body">— {{ slides[current].author }}</p>
          </div>
        </div>
      </transition> -->

      <!-- Dots -->
      <!-- <div class="auth-left__dots">
        <span
          v-for="(s, i) in slides"
          :key="i"
          class="auth-left__dot"
          :class="{ 'auth-left__dot--active': i === current }"
          @click="current = i"
        />
      </div>
    </div> -->
  </div>
</template>

<script>
import LOGO from "../../constants/logo";

export default {
  name: "AuthLeftPanel",
  data() {
    return {
      current: 0,
      logoFailed: false,
      timer: null,
      logoText: LOGO.text,
      imageUrl: LOGO.dark,
      slides: [
        {
          img: "/img/stock.png",
          text: "Бонд, IPO болон бусад үнэт цаасны багцыг нэг платформ дээр удирдах боломж нь шийдвэр гаргалтад их дэмжлэг болдог.",
          author: "Болдмаа",
        },
        {
          img: "/img/stock.png",
          text: "Эрсдэл, егөөжийн харагдац маш сайн. Хөрөнгө оруулалтаа илүү ухаалгаар удирдаж чадлаа.",
          author: "Мөнхбаяр",
        },
        {
          img: "/img/stock.png",
          text: "Шинжилгээний хэрэгслүүд нь бодит цаг хугацааны мэдээлэлтэй хамтран ажилладаг.",
          author: "Энхтүвшин",
        },
      ],
    };
  },
  mounted() {
    this.timer = setInterval(() => {
      this.current = (this.current + 1) % this.slides.length;
    }, 4000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    onLogoError() {
      this.logoFailed = true;
    },
  },
};
</script>

<style scoped>
.auth-left {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 48px 40px;
  height: 100%;
  position: relative;
  background: url("/img/bg 1.png") center center / cover no-repeat;
  color: #fff;
  padding: 10%;
  padding-top: 100px;
}
.auth-left::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    160deg,
    rgba(20, 42, 120, 0.82) 0%,
    rgba(30, 70, 180, 0.75) 50%,
    rgba(40, 90, 200, 0.7) 100%
  );
  pointer-events: none;
  z-index: 0;
}
.auth-left > * {
  position: relative;
  z-index: 1;
}

/* Logo */
.auth-left__logo {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.auth-left__logo-wrap {
  display: inline-flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
}
.auth-left__logo-underline {
  width: 100%;
  height: 1px;
  background: var(--ui-secondary);
  border-radius: 2px;
}
.auth-left__logo-img {
  max-height: auto;
  max-width: 280px;
  object-fit: contain;
}
.auth-left__logo-text {
  font-size: 26px;
  font-weight: 800;
  color: #fff;
  letter-spacing: 0.5px;
}

/* Tagline */
.auth-left__tagline {
  color: rgba(255, 255, 255, 0.75) !important;
  margin-top: 16px;
  line-height: 1.6;
}

/* Carousel */
.auth-left__carousel {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 20px;
}

.auth-left__slide {
  background: rgba(255, 255, 255, 0.08);
  border: 0.5px solid #e8871e;
  border-radius: 16px;
  padding: 24px;
}

.auth-left__quote {
  line-height: 1.65;
  color: rgba(255, 255, 255, 0.9) !important;
  margin: 0 0 10px;
  border: none;
  padding: 0;
}

.auth-left__author {
  color: rgba(255, 255, 255, 0.6) !important;
  margin: 0;
}

/* Dots */
.auth-left__dots {
  display: flex;
  gap: 8px;
  justify-content: center;
  color: var(--ui-secondary);
}
.auth-left__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: transparent;
  border: 1px solid var(--ui-secondary);
  cursor: pointer;
  transition: background 0.25s, transform 0.25s;
}
.auth-left__dot--active {
  background: var(--ui-secondary);
  border-color: var(--ui-secondary);
  transform: scale(1.2);
}

/* Fade transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
